<template>
  <label class="radio-component" :for="id">
    <input
      class="radio-component-input"
      type="radio"
      :disabled="disabled"
      :id="id"
      :checked="checked"
      :name="name"
      :value="value"
      v-model="localVModel"
    >
    <span class="radio-component-label" :class="{ '--disabled': disabled }" />
    <slot />
  </label>
</template>

<script>
// https://forum.vuejs.org/t/v-model-does-not-check-radio-button-in-custom-component/56396/3
export default {
  model: {
    prop: 'vModelProp',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: () => {
        return Math.random().toString().substring(7)
      },
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
      required: false, // set to false support null value
    },
    vModelProp: {
      type: [String, Number, Boolean],
      default: null,
      required: false, // set to false support null value
    },
    name: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localVModel: {
      get() {
        return this.vModelProp
      },
      set() {
        this.$emit('change', this.value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.radio-component {
  @apply flex items-center;
  @apply cursor-pointer;
}

.radio-component-input {
  @apply mr-2 hidden;
}

.radio-component-label {
  @apply relative inline-block w-3.5 h-3.5 rounded-full bg-base-0 border border-secondary-40 mr-2;
  @apply flex-shrink-0;

  &.--disabled {
    @apply cursor-not-allowed;
  }
}

.radio-component-input:checked {
  + .radio-component-label:after {
    content: "";
    @apply w-2 h-2 bg-secondary-50 absolute top-0.5 left-0.5 rounded-full;
  }
  + .radio-component-label.--disabled:after {
    @apply bg-base-60;
  }
}
</style>
